import { render, staticRenderFns } from "./ModuleTitle.vue?vue&type=template&id=3b2ec470&scoped=true"
import script from "./ModuleTitle.vue?vue&type=script&lang=js"
export * from "./ModuleTitle.vue?vue&type=script&lang=js"
import style0 from "./ModuleTitle.vue?vue&type=style&index=0&id=3b2ec470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ec470",
  null
  
)

export default component.exports